export const Config = Object.freeze({
  /**
   * log 日志方法使用的 logger, 发布时改为 null 来禁用 log 的输出
   */
  logger: console.log,
  /**
   * 单价精度
   */
  pricePrecision: 6
});
